module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("mmmmm something went wrong")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e96ab76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/ErrorView.vue
// module id = 1517
// module chunks = 4